<div>
    <app-audi-text variant="order4" className="audi-type-normal" weight="bold" text="Vehicle Details"></app-audi-text>
    <br /><br />

    <div class="column__list">
        <div class="card__list">
            <app-audi-select inputId="jb-vd-model-select" label="Vehicle Model*" [options]="modelOptions" [(value)]="selectedModel" (valueChange)="onModelSelected($event)"
                isRequired="true">
            </app-audi-select>
        </div>
        <div class="card__list">
            <app-audi-select inputId="jb-vd-model-year-select" label="Model Year*" [options]="modelYearOptions" [(value)]="selectedModelYear" (valueChange)="onModelYearSelected()"
                isRequired="true">
            </app-audi-select>
        </div>
        <div class="card__list">
            <app-audi-text-input inputId="odometerReading" label="Odometer Reading*" [(value)]="currentOdometer" isRequired="true" (valueChange)="onCurrentOdometerChanged()"
                validationMessage="{{odometerValidationMessage}}">
            </app-audi-text-input>
        </div>
    </div>

    <div>
        <p-carousel #carousel [value]="cars" [page]="carouselPageIndex" [numVisible]="numVisible" [numScroll]="numScroll" [responsiveOptions]="responsiveOptions"
            (onPage)="onCarouselPage($event)">
            <ng-template let-car pTemplate="item">
                <div class="carousel-item" (click)="carouselItemClicked(car)">
                    <span>{{car}}</span>
                    <br />
                    <img class="carousel-image" src="{{contentImages | ContentImage:car}}" alt="model image">
                </div>
            </ng-template>
        </p-carousel>
    </div>

    <app-audi-text variant="order4" className="audi-type-normal" weight="bold" text="Current Plan Details"></app-audi-text>
    <br /><br />

    <div class="column__list">
        <div class="card__list">
            <app-audi-select inputId="customize-plan-type-select" label="Plan Type*" [options]="planTypeOptions" [(value)]="selectedPlanType" (valueChange)="onPlanTypeSelected()"
                isRequired="true">
            </app-audi-select>
        </div>
        <div>
            <div class="card__list">
                <div [hidden]="isPlanTypeUnknown">
                    <app-audi-select inputId="customize-plan-years-select" label="Years*" [options]="yearsOptions" [(value)]="selectedYears" (valueChange)="onYearsSelected()"
                        isRequired="true">
                    </app-audi-select>
                </div>
            </div>
        </div>
        <div>
            <div class="card__list">
                <div [hidden]="isPlanTypeUnknown">
                    <app-audi-select inputId="customize-plan-distance-select" label="Distance*" [options]="distanceOptions" [(value)]="selectedDistance"
                        (valueChange)="onDistanceSelected()" isRequired="true">
                    </app-audi-select>
                </div>
            </div>
        </div>
    </div>

    <div>
        <app-audi-text variant="copy2" text="* Indicates required fields"></app-audi-text><br /><br />
        <app-audi-button text="Continue" (click)="onContinue()" [disabled]="!canContinue"></app-audi-button>
        <br /><br />
        <app-audi-button text="Back" (click)="onBack()" variant="secondary"></app-audi-button>
    </div>

    <br />
    <div>
        <app-audi-text text="{{contentTexts | ContentText:'Disclaimer'}}" variant="copy1" color="secondary">
        </app-audi-text>
    </div>
</div>